import { faLink } from "@fortawesome/pro-duotone-svg-icons/faLink";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_CONNECTIONS_LINK: Breadcrumb = {
  icon: faLink,
  name: "Connections",
  to: "/dashboard/connections",
};
